import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
export function OfferBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 30,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 0;
          seconds = 0;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-deco-terra text-white py-2.5 px-4" data-id="element-112" data-mp="a9tkql56vw92">
      <div className="flex items-center justify-center gap-2 sm:gap-3 flex-wrap text-xs sm:text-sm font-bold tracking-wide" data-id="element-113" data-mp="3sj3v23znqmts">
        <div className="flex items-center gap-1.5" data-id="element-114" data-mp="1dkm38p1d1nz">
          <Flame size={14} className="shrink-0" data-id="element-115" data-mp="qyk2nuvwt9u6" />
          <span className="uppercase" data-id="element-116" data-mp="r1emplb0gsn2">Oferta especial</span>
        </div>
        <span className="hidden sm:inline text-white/60" data-id="element-117" data-mp="mx6wtksth6n9">—</span>
        <span className="text-white/90 font-medium" data-id="element-118" data-mp="10y16e6rlpdni">Termina en</span>
        <div className="flex items-center gap-1 font-mono" data-id="element-119" data-mp="10v58ujjo0qzl">
          <motion.span key={`m-${timeLeft.minutes}`} initial={{
          scale: 1.15,
          opacity: 0.6
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.2
        }} className="bg-white/20 rounded px-1.5 py-0.5 min-w-[28px] text-center" data-id="element-120" data-mp="vzpu7pdu2r24">
            {pad(timeLeft.minutes)}
          </motion.span>
          <span className="text-white/60" data-id="element-121" data-mp="d7exyedoprcz">:</span>
          <motion.span key={`s-${timeLeft.seconds}`} initial={{
          scale: 1.15,
          opacity: 0.6
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.2
        }} className="bg-white/20 rounded px-1.5 py-0.5 min-w-[28px] text-center" data-id="element-122" data-mp="d6m1q7ccqk93">
            {pad(timeLeft.seconds)}
          </motion.span>
        </div>
      </div>
    </div>;
}